import { SelectBox, TextBox } from 'devextreme-react';
import { NumberBox } from 'devextreme-react/number-box';
import CheckBox from 'devextreme-react/check-box';
import { IconButton } from '@material-ui/core';
import addIcon from '../../../../../images/iconoAdd.svg';
import clearIcon from '../../../../../images/clear.png';

function InputWrapper(props) {
  const { classes, label } = props;
  return (
    <div className="dx-field">
      <label className={classes.label}>{label}</label>
      <div style={{ width: '100%' }} className="dx-field-value">
        {props.children}
      </div>
    </div>
  );
}

export default function ModelSelector(props) {
  return (
    <div style={{ border: '1px solid white', padding: '0 4px 4px 4px', marginTop: 5, backgroundColor: '#36363d' }}>
      <InputWrapper classes={props.classes} label={'Modelo'}>
        <div style={{ display: 'flex' }}>
          <SelectBox
            key={`model-${props.modelIndex}`}
            valueExpr={'modelId'}
            displayExpr="modelName"
            value={props.data?.modelId}
            onValueChanged={(e) => props.handleModelChange(props.brandIndex, props.modelIndex, 'modelId', e.value)}
            placeholder=""
            dataSource={props.models}
            height={25}
            width={230}
          ></SelectBox>
          <IconButton onClick={(e) => props.removeModel(props.brandIndex, props.modelIndex)} style={{ backgroundColor: '#d47f7f', padding: 2, marginLeft: 5 }}>
            <img src={clearIcon} alt="Remover modelo" title={'Remover modelo'} width={20} />
          </IconButton>
        </div>
      </InputWrapper>

      <div className={props.classes.input_grid}>
        <InputWrapper classes={props.classes} label={'Quantidade'}>
          <NumberBox
            key={`model-quantity-${props.modelIndex}`}
            defaultValue={1}
            value={props.data?.quantity}
            showSpinButtons={true}
            showClearButton={true}
            min={1}
            max={100}
            onValueChanged={(e) => props.handleModelChange(props.brandIndex, props.modelIndex, 'quantity', e.value)}
            height={25}
          />
        </InputWrapper>
        <InputWrapper classes={props.classes} label={'Descons. rebate (%)'}>
          <NumberBox
              key={`model-disregardRebatePercent-${props.modelIndex}`}
              value={props.data?.disregardRebatePercent || 0}
              showSpinButtons={true}
              showClearButton={true}
              format="0.##'%'"
              min={0.0}
              onValueChanged={(e) => props.handleModelChange(props.brandIndex, props.modelIndex, 'disregardRebatePercent', e.value)}
              height={25}
            />
        </InputWrapper>
      </div>

      <InputWrapper classes={props.classes} label={'Observações'}>
        <TextBox
          key={`model-observations-${props.modelIndex}`}
          value={props.data?.observations}
          name="observations"
          placeholder="ex: Cor e local de entraga"
          onValueChanged={(e) => props.handleModelChange(props.brandIndex, props.modelIndex, 'observations', e.value)}
          className={props.classes.controlers}
          height={25}
        ></TextBox>
      </InputWrapper>
    </div>
  );
}
